import { Stage } from "../helpers/workflow.types";

export const DEFAULT_STAGE:Stage = {
  stageId: 1,
  stageName: "Not Started",
};
